import { ErrorState } from '@/components/common/States'
import { Skeleton } from '@/components/ui/skeleton'
import { useAuth } from '@/lib/auth/AuthProvider'
import { useDashboardLayout } from './api'
import { LayoutEditor } from './edit/LayoutEditor'

export function DashboardEditPage() {
  const { user } = useAuth()
  const layout = useDashboardLayout()

  if (layout.isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-24 rounded-xl" />
        <div className="grid gap-4 lg:grid-cols-[260px_minmax(0,1fr)] xl:grid-cols-[260px_minmax(0,1fr)_300px]">
          <Skeleton className="h-[480px] rounded-2xl" />
          <Skeleton className="h-[480px] rounded-2xl" />
          <Skeleton className="hidden h-[480px] rounded-2xl xl:block" />
        </div>
      </div>
    )
  }
  if (layout.isError || !layout.data) return <ErrorState error={layout.error} onRetry={() => void layout.refetch()} />

  return <LayoutEditor userId={user?.id ?? 'anon'} saved={layout.data.widgets} />
}
